import loadable from '@loadable/component'

export const SubHeading = loadable(() => import('./SubHeading'))
export type { SubHeadingProps } from './SubHeading'
